export const DEFAULT_PROFILE_IMAGE =
  'https://nogglsilnolluhkmrvqx.supabase.co/storage/v1/object/public/profile/img.jpg';

export const PROFILE_BASE_URL = 'https://sontbthwhfethyggenin.supabase.co/storage/v1/object/public/profile/';
